import { defineComponent as n, openBlock as t, createElementBlock as Z, mergeProps as v, unref as H, renderSlot as r, createElementVNode as o, createCommentVNode as s } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const d = { key: 0 }, p = { key: 1 }, i = { key: 2 }, u = { key: 3 }, g = { key: 4 }, A = { key: 5 }, f = {
  name: "ScalarIconWall"
}, y = /* @__PURE__ */ n({
  ...f,
  props: {
    label: {},
    weight: {}
  },
  setup(h) {
    const l = h, { bind: m, weight: e } = M(l);
    return (a, V) => (t(), Z("svg", v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, H(m)), [
      r(a.$slots, "default"),
      H(e) === "bold" ? (t(), Z("g", d, V[0] || (V[0] = [
        o("path", { d: "M224,44H32A12,12,0,0,0,20,56V200a12,12,0,0,0,12,12H224a12,12,0,0,0,12-12V56A12,12,0,0,0,224,44ZM92,140V116h72v24Zm-48,0V116H68v24Zm144-24h24v24H188Zm24-24H140V68h72ZM116,68V92H44V68ZM44,164h72v24H44Zm96,24V164h72v24Z" }, null, -1)
      ]))) : H(e) === "duotone" ? (t(), Z("g", p, V[1] || (V[1] = [
        o("path", {
          d: "M128,104H32V56h96Zm48,0v48H128v48h96V104Z",
          opacity: "0.2"
        }, null, -1),
        o("path", { d: "M224,48H32a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V56A8,8,0,0,0,224,48ZM88,144V112h80v32Zm-48,0V112H72v32Zm144-32h32v32H184Zm32-16H136V64h80ZM120,64V96H40V64ZM40,160h80v32H40Zm96,32V160h80v32Z" }, null, -1)
      ]))) : H(e) === "fill" ? (t(), Z("g", i, V[2] || (V[2] = [
        o("path", { d: "M232,56V88a4,4,0,0,1-4,4H136V52a4,4,0,0,1,4-4h84A8,8,0,0,1,232,56Zm-4,52H184v44h44a4,4,0,0,0,4-4V112A4,4,0,0,0,228,108ZM88,152h80V108H88Zm-60,0H72V108H28a4,4,0,0,0-4,4v36A4,4,0,0,0,28,152Zm200,16H136v36a4,4,0,0,0,4,4h84a8,8,0,0,0,8-8V172A4,4,0,0,0,228,168ZM28,92h92V52a4,4,0,0,0-4-4H32a8,8,0,0,0-8,8V88A4,4,0,0,0,28,92Zm-4,80v28a8,8,0,0,0,8,8h84a4,4,0,0,0,4-4V168H28A4,4,0,0,0,24,172Z" }, null, -1)
      ]))) : H(e) === "light" ? (t(), Z("g", u, V[3] || (V[3] = [
        o("path", { d: "M224,50H32a6,6,0,0,0-6,6V200a6,6,0,0,0,6,6H224a6,6,0,0,0,6-6V56A6,6,0,0,0,224,50ZM86,146V110h84v36Zm-48,0V110H74v36Zm144-36h36v36H182Zm36-12H134V62h84ZM122,62V98H38V62ZM38,158h84v36H38Zm96,36V158h84v36Z" }, null, -1)
      ]))) : H(e) === "regular" ? (t(), Z("g", g, V[4] || (V[4] = [
        o("path", { d: "M224,48H32a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V56A8,8,0,0,0,224,48ZM88,144V112h80v32Zm-48,0V112H72v32Zm144-32h32v32H184Zm32-16H136V64h80ZM120,64V96H40V64ZM40,160h80v32H40Zm96,32V160h80v32Z" }, null, -1)
      ]))) : H(e) === "thin" ? (t(), Z("g", A, V[5] || (V[5] = [
        o("path", { d: "M224,52H32a4,4,0,0,0-4,4V200a4,4,0,0,0,4,4H224a4,4,0,0,0,4-4V56A4,4,0,0,0,224,52ZM84,148V108h88v40Zm-48,0V108H76v40Zm144-40h40v40H180Zm40-8H132V60h88ZM124,60v40H36V60ZM36,156h88v40H36Zm96,40V156h88v40Z" }, null, -1)
      ]))) : s("", !0)
    ], 16));
  }
});
export {
  y as default
};
